import classNames from 'classnames/bind';

import getPriceInfo from '../helpers/getPriceInfo';
import { GUEST_PLAN } from '../../../data/subscriptionPlans';
import withComponentName from '../../../decorators/withComponentName';
import usePriceCurrency from '../PriceCurrencyProvider/usePriceCurrency';

import Styles from './pricingPlansTableHeader.module.scss';

const cx = classNames.bind(Styles);

const PlanItemTableHeader = (props) => {
  const {
    isHeader,
    images,
    text,
    plan = false,
    basic = false,
    silver = false,
    gold = false,
    userPlan,
    isUserWithPlan,
    activePlane,
    current_plan,
    planPriceInfo,
  } = props;
  const { currency } = usePriceCurrency();

  const pricingPlansInner = cx('pricing_plan_inner', {
    guest: userPlan === GUEST_PLAN,
    'registered-user-plan': isUserWithPlan,
    'user-gold-plan': userPlan === 'gold_plan' && gold,
    'user-silver-plan': userPlan === 'silver_plan' && silver,
    'user-basic-plan': userPlan === 'basic_plan' && basic,
    gold,
    basic,
    silver,
    plan,
    active: activePlane === current_plan,
  });

  const {
    smallestPrice,
    largestPrice,
  } = getPriceInfo({
    basic,
    planPriceInfo,
    currency,
  });

  return (
    <div className={pricingPlansInner}>
      <div className={Styles['plan-body']}>
        <div className={Styles['plan-body-inner']}>
          <div className={Styles.plan_img_holder}>
            {
              isHeader
                ? null
                : (
                  <HeaderColumn
                    basic={basic}
                    silver={silver}
                    gold={gold}
                    text={text}
                    images={images}
                    smallestPrice={smallestPrice}
                    largestPrice={largestPrice}
                  />
                )
            }
          </div>
        </div>
      </div>
    </div>
  );
};

const HeaderColumn = ({
  basic, silver, gold, text, images,
  smallestPrice, largestPrice,
}) => {
  const { currencySymbol, currencyCode } = usePriceCurrency();
  const planImg = cx('plan_img', {
    basic,
    silver,
    gold,
  });

  const planTitleClass = cx('plan_title', {
    'gold-plan-title': gold,
    'basic-plan-title': basic,
    'silver-plan-title': silver,
  });

  return (
    <>
      <div className={planTitleClass}>
        {basic && (<p>{text}</p>)}
        {!basic && (
          <div className={Styles['price-start']}>
            <div className={Styles.value}>
              <span className={Styles.cost}>
                {currencySymbol}
                {`${smallestPrice}${largestPrice !== smallestPrice ? `-${largestPrice}` : ''}`}
              </span>
              {' '}
              {currencyCode}
              /mo
            </div>
            {silver && (
              <div className={Styles['silver-trial-badge']}>
                Try 7-days FREE trial!
              </div>
            )}
          </div>
        )}
      </div>
      <div className={planImg}>
        <picture className="text-center">
          <source media="(max-width: 767px)" srcSet={images.smallImg} />
          <source media="(max-width: 1023px)" srcSet={images.mediumImg} />
          <img src={images.bigImg} alt="Blue bird" />
        </picture>
      </div>
    </>
  );
};

export default withComponentName(PlanItemTableHeader);
